import { Capacitor } from "@capacitor/core";
import { Storage as CapacitorStorage } from "@capacitor/storage";
import Dexie from "dexie";

const isNative = Capacitor.isNativePlatform();

// Setup Dexie for web
let db = null;

if (!isNative) {
  db = new Dexie("PosAppDatabase");
  db.version(1).stores({
    keyval: "&key", // Unique key
  });
  db = {
    keyval: db.table("keyval"),
  };
}

export const storage = {
  // Store or replace value
  async set(key, value) {
    if (isNative) {
      await CapacitorStorage.set({ key, value });
    } else {
      await db.keyval.put({ key, value });
    }
  },

  // Get value by key
  async get(key) {
    if (isNative) {
      const result = await CapacitorStorage.get({ key });
      return result.value ?? null;
    } else {
      const result = await db.keyval.get(key);
      return result ? result.value : null;
    }
  },

  // Remove item by key
  async remove(key) {
    if (isNative) {
      await CapacitorStorage.remove({ key });
    } else {
      await db.keyval.delete(key);
    }
  },

  // Clear all key-values
  async removeAll() {
    const cookiesAccepted = (await this.get("acceptedCookies")) || false;
    if (isNative) {
      await CapacitorStorage.clear();
    } else {
      await db.keyval.clear();
    }
    this.set("acceptedCookies", cookiesAccepted);
  },
};
